module.exports = __webpack_public_path__ + "static/media/cookie-open.d1c4b1c1.png";